import {
  CircularProgress,
  FormControl,
  FormHelperText,
  TextField
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { usePopup } from "hooks/usePopup";
import { useEffect, useState } from "react";
import userService from "services/userService";
import { useDebaunce } from "utils";

const formatData = data => {
  return data.map(item => {
    const { id, username } = item;
    return { id, username };
  });
};

const AutoCompleteUserFormik = ({
  className,
  formik,
  name,
  onChange,
  groupId,
  label = "Nome do responsável"
}) => {
  const { addPopup } = usePopup();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const value = formik?.values?.[name];
  const hasError =
    (formik.touched[name] || formik.submitCount > 0) && !!formik.errors[name];

  const handleUserData = async (search = undefined) => {
    try {
      setLoading(true);
      const { data } = await userService.getUsers({
        page: 1,
        pageSize: 15,
        search,
        ...(groupId && { groupId })
      });

      setOptions(formatData(data.results));
    } catch (err) {
      if (err?.response?.status) {
        addPopup({
          type: "error",
          title: "Desculpe, ocorreu um erro",
          description: "Erro ao pesquisar usuário."
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const debaunce = useDebaunce({ fn: handleUserData, delay: 500 });

  const handleUser = (e, value) => debaunce(value?.trim());

  useEffect(() => {
    handleUserData();
  }, []);

  return (
    <FormControl fullWidth disabled={formik?.isSubmitting} error={hasError}>
      <Autocomplete
        loading={loading}
        options={options}
        getOptionLabel={option => option.username}
        getOptionSelected={(item, current) => item.value === current.value}
        className={className}
        noOptionsText="Usuário não encontrado"
        loadingText="Procurando usuário..."
        value={value}
        onChange={(_, value) => {
          formik.setFieldValue(name, value);
          onChange && onChange(value);
        }}
        onBlur={formik.handleBlur}
        onInputChange={handleUser}
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            error={hasError}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        )}
      />
      <FormHelperText>{hasError && formik.errors[name]}</FormHelperText>
    </FormControl>
  );
};

export default AutoCompleteUserFormik;
